import {
  AnalyticsMediator,
  OneTrustConsentPlugin,
  ConsentMediator,
  RudderstackAnalyticsPlugin,
} from 'allbirds-analytics';
import Settings from 'utils/Settings';
import UnifiedLogger from 'utils/UnifiedLogger';

import { SHOP_SETTINGS } from './constants';

let _mediator;

const AnalyticsMediatorSingleton = class {
  static init = () => {
    if (_mediator) {
      return _mediator;
    }

    const shopConfig = SHOP_SETTINGS[Settings.shopID];
    const analyticsLogger = new UnifiedLogger('allbirds-analytics');

    _mediator = new AnalyticsMediator({
      plugins: [RudderstackAnalyticsPlugin({ window, logger: analyticsLogger, shopConfig })],
      consentMediator: new ConsentMediator(
        new OneTrustConsentPlugin(window, shopConfig, analyticsLogger),
        analyticsLogger
      ),
      logger: analyticsLogger,
      shopConfig,
    });

    _mediator.initialize();

    return _mediator;
  };

  static get = () => {
    return AnalyticsMediatorSingleton.init();
  };
};

export default AnalyticsMediatorSingleton;
